import {Directive, Renderer, ElementRef} from '@angular/core';
// import {Keyboard} from '@ionic-native/keyboard';

@Directive({
  selector: '[focuser]' // Attribute selector
})
export class FocuserDirective {
  constructor(
    private renderer: Renderer,
    private elementRef: ElementRef,
    // private keyboard: Keyboard
  ) {
  }

  ngAfterViewInit() {
    const element = this.elementRef.nativeElement.querySelector('input');
    // we need to delay our call in order to work with ionic ...
    setTimeout(() => {
      this.renderer.invokeElementMethod(element, 'focus', []);
      // this.keyboard.show();
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/directives/focuser/focuser.ts